function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

// for nodejs
// import {is_string, is_hex} from "./helpers.js"
// import Run from "run-sdk"
// import pAny from "p-any"
// import fetch from "node-fetch"
// const Promise_Any = pAny
// import retry from 'async-retry'
// import pSome from "p-some"
// for react/web
import { is_string, is_hex } from "./helpers.js"; //var Run = require("runlib") // load RUN through webpack externals 

var Promise_Any = require('p-any');

Promise_Any = Promise_Any.default;

var fetch = require('node-fetch');

var retry = require("async-retry");

var pSome = require('p-some'); // const pTimeout = require('p-timeout')


var Run = window.Run; // ----------------------------------------------
// TODO add handling for AggregateError from p-any if they all reject

function is_empty_obj(obj) {
  return obj // 👈 null and undefined check
  && Object.keys(obj).length === 0 && obj.constructor === Object;
}

var get_spend_txid_mattercloud = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(location) {
    var response, cors_proxy, test_url;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            cors_proxy = ""; //"https://zhell-cors-escape.herokuapp.com/"

            test_url = cors_proxy + "https://txdb.mattercloud.io/api/v1/spends/" + location;
            _context.prev = 2;
            _context.next = 5;
            return fetch(test_url);

          case 5:
            response = _context.sent;
            _context.next = 8;
            return response.json();

          case 8:
            response = _context.sent;
            _context.next = 15;
            break;

          case 11:
            _context.prev = 11;
            _context.t0 = _context["catch"](2);
            console.error("error fetching mattercloud:", _context.t0);
            throw _context.t0;

          case 15:
            if (!(response && response.result && response.result[location] && response.result[location].spend_txid)) {
              _context.next = 19;
              break;
            }

            return _context.abrupt("return", response.result[location].spend_txid);

          case 19:
            return _context.abrupt("return", null);

          case 20:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[2, 11]]);
  }));

  return function get_spend_txid_mattercloud(_x) {
    return _ref.apply(this, arguments);
  };
}();
/**
 * Note on caching: If you want to optimise this CustomBlockchain implementation,
 * set a cache:... to options passed in constructor
 * that way fetch will not refetch if it's in the cache already
 */


var CustomBlockchain = /*#__PURE__*/function (_Run$api$Blockchain) {
  _inherits(CustomBlockchain, _Run$api$Blockchain);

  var _super = _createSuper(CustomBlockchain);

  function CustomBlockchain(options, mattercloud_APIkey) {
    var _this;

    _classCallCheck(this, CustomBlockchain);

    _this = _super.call(this); //

    _this.DEBUG = false;
    _this.retry_config = {
      retries: 10,
      // 10
      minTimeout: 50,
      // in ms
      maxTimeout: 2000,
      // in ms
      factor: 2 // exponential-backoff factor
      // => 50, 100, 200, 400, 800, 1000, 1000, 1000, 1000, 1000
      // => the last retry happens after 6.5 seconds

    }; //

    _this.blockchains = [];
    _this.options = options;

    var log = function log() {
      var _console;

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      (_console = console).log.apply(_console, ["CustomBlockchain: "].concat(args));
    };

    _this.log = log; //

    if (options.cache) _this.cache = options.cache;
    var options_copy = JSON.parse(JSON.stringify(options)); //
    // run api

    _this.blockchain_runapi = new Run(options).blockchain;
    log("this.blockchain_runapi = ", _this.blockchain_runapi);

    _this.blockchains.push(_this.blockchain_runapi); //
    // mattercloud // deprecated
    // if(options.cache) options_copy.cache 	 = options.cache
    // log("CustomBlockchain: options_copy = ",options_copy,"\n vs \n options=",options)
    // options_copy.api  	 = "mattercloud"
    // options_copy.network = "main" //mattercloud only works on mainnet
    // options_copy.apiKey  = mattercloud_APIkey
    // this.blockchain_mattercloud = (new Run(options_copy)).blockchain
    // this.blockchains.push(this.blockchain_mattercloud)
    //
    // whatsonchain 


    options_copy = JSON.parse(JSON.stringify(options));
    if (options.cache) options_copy.cache = options.cache;
    options_copy.api = "whatsonchain";
    _this.blockchain_whatsonchain = new Run(options_copy).blockchain;

    _this.blockchains.push(_this.blockchain_whatsonchain);

    return _this;
  }

  _createClass(CustomBlockchain, [{
    key: "network",
    get: function get() {
      if (this.blockchain_runapi) return this.blockchain_runapi.network;
      return "main"; // default
    }
  }, {
    key: "broadcast",
    value: function () {
      var _broadcast2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(rawtx) {
        var _this2 = this;

        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return retry( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
                  return regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                      switch (_context2.prev = _context2.next) {
                        case 0:
                          _context2.next = 2;
                          return _this2._broadcast(rawtx);

                        case 2:
                          return _context2.abrupt("return", _context2.sent);

                        case 3:
                        case "end":
                          return _context2.stop();
                      }
                    }
                  }, _callee2);
                })), this.retry_config);

              case 2:
                return _context3.abrupt("return", _context3.sent);

              case 3:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function broadcast(_x2) {
        return _broadcast2.apply(this, arguments);
      }

      return broadcast;
    }()
  }, {
    key: "_broadcast",
    value: function () {
      var _broadcast3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(rawtx) {
        var _this3 = this;

        var log, allpromises, res_any, res_some_1, _yield$pSome, _yield$pSome2;

        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                log = function log() {
                  for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
                    args[_key2] = arguments[_key2];
                  }

                  return _this3.log.apply(_this3, ["broadcast(): "].concat(args));
                };

                if (this.DEBUG) log("DEBUG");

                if (is_string(rawtx)) {
                  _context4.next = 4;
                  break;
                }

                throw new Error(["CustomBlockchain: broadcast(): must be string, got rawtx:[", _typeof(rawtx), "]=", JSON.stringify(rawtx)].join(' '));

              case 4:
                //
                // our goal is to broadcast to ALL blockchains (runapi & mattercloud) to increase reliability
                // and take the response from the FIRST one that fulfils it
                allpromises = [];
                this.blockchains.forEach(function (blockchain) {
                  allpromises.push(blockchain.broadcast(rawtx));
                });
                _context4.prev = 6;
                _context4.next = 9;
                return pSome(allpromises, {
                  count: 1
                });

              case 9:
                _yield$pSome = _context4.sent;
                _yield$pSome2 = _slicedToArray(_yield$pSome, 1);
                res_some_1 = _yield$pSome2[0];
                res_any = res_some_1;
                _context4.next = 19;
                break;

              case 15:
                _context4.prev = 15;
                _context4.t0 = _context4["catch"](6);
                console.error("CustomBlockchain: broadcast(): all blockchains failed for broadcasting rawtx=", rawtx);
                throw new Error(["CustomBlockchain: broadcast(): all blockchains failed for", rawtx].join(' '));

              case 19:
                if (!(!is_string(res_any) || res_any.length === 0 || !is_hex(res_any))) {
                  _context4.next = 21;
                  break;
                }

                throw new Error(["CustomBlockchain: broadcast(): res_any should be an hex string but got:", res_any].join(' '));

              case 21:
                return _context4.abrupt("return", String(res_any));

              case 22:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this, [[6, 15]]);
      }));

      function _broadcast(_x3) {
        return _broadcast3.apply(this, arguments);
      }

      return _broadcast;
    }()
  }, {
    key: "fetch",
    value: function () {
      var _fetch2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(txid) {
        var _this4 = this;

        var force,
            _args6 = arguments;
        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                force = _args6.length > 1 && _args6[1] !== undefined ? _args6[1] : false;
                _context6.next = 3;
                return retry( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
                  return regeneratorRuntime.wrap(function _callee5$(_context5) {
                    while (1) {
                      switch (_context5.prev = _context5.next) {
                        case 0:
                          _context5.next = 2;
                          return _this4._fetch(txid, force = false);

                        case 2:
                          return _context5.abrupt("return", _context5.sent);

                        case 3:
                        case "end":
                          return _context5.stop();
                      }
                    }
                  }, _callee5);
                })), this.retry_config);

              case 3:
                return _context6.abrupt("return", _context6.sent);

              case 4:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function fetch(_x4) {
        return _fetch2.apply(this, arguments);
      }

      return fetch;
    }()
  }, {
    key: "_fetch",
    value: function () {
      var _fetch3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8(txid) {
        var _this5 = this;

        var force,
            log,
            _rawtx,
            allpromises,
            res_any,
            response,
            cors_server,
            test_url,
            error,
            rawtx,
            _args8 = arguments;

        return regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                force = _args8.length > 1 && _args8[1] !== undefined ? _args8[1] : false;

                log = function log() {
                  for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
                    args[_key3] = arguments[_key3];
                  }

                  return _this5.log.apply(_this5, ["fetch(): "].concat(args));
                };

                if (this.DEBUG) log("with txid=" + txid + " (" + _typeof(txid) + "), force=" + force);

                if (is_string(txid)) {
                  _context8.next = 5;
                  break;
                }

                throw new Error(["CustomBlockchain: fetch(): must be string, got txid:[", _typeof(txid), "]=", JSON.stringify(txid)].join(' '));

              case 5:
                if (!this.cache) {
                  _context8.next = 12;
                  break;
                }

                _context8.next = 8;
                return this.cache.get("tx://" + txid);

              case 8:
                _rawtx = _context8.sent;

                if (!_rawtx) {
                  _context8.next = 12;
                  break;
                }

                if (this.DEBUG) log("found in cache: ", txid);
                return _context8.abrupt("return", _rawtx);

              case 12:
                //
                // is doing this a security risk?
                // // unban the tx in all blockchains to make sure we will be able to fetch
                // await Promise.all(this.blockchains.map(async (blockchain) => {
                // 	await blockchain.cache.set('ban://'+txid, false)
                // }))
                //
                // our goal is to talk with ALL blockchains to increase reliability
                // and take the response from the FIRST one that fulfils it
                allpromises = [];
                this.blockchains.forEach( /*#__PURE__*/function () {
                  var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7(blockchain) {
                    return regeneratorRuntime.wrap(function _callee7$(_context7) {
                      while (1) {
                        switch (_context7.prev = _context7.next) {
                          case 0:
                            allpromises.push(blockchain.fetch(txid, force));

                          case 1:
                          case "end":
                            return _context7.stop();
                        }
                      }
                    }, _callee7);
                  }));

                  return function (_x6) {
                    return _ref4.apply(this, arguments);
                  };
                }());
                _context8.prev = 14;
                _context8.next = 17;
                return Promise_Any(allpromises);

              case 17:
                res_any = _context8.sent;
                _context8.next = 37;
                break;

              case 20:
                _context8.prev = 20;
                _context8.t0 = _context8["catch"](14);
                // TODO requires cors server !
                cors_server = ""; // "https://zhell-cors-escape.herokuapp.com/"

                test_url = cors_server + "https://api.whatsonchain.com/v1/bsv/main/tx/" + txid + "/hex";
                _context8.prev = 24;
                _context8.next = 27;
                return fetch(test_url);

              case 27:
                response = _context8.sent;
                response = response.json();
                _context8.next = 34;
                break;

              case 31:
                _context8.prev = 31;
                _context8.t1 = _context8["catch"](24);
                console.error("error fetching whatsonchain:", _context8.t1);

              case 34:
                error = ["CustomBlockchain: fetch(): all blockchains failed for", txid].join(' ');
                console.error(error, " vs response=", response); // throw new Error(error)

                throw new Error(_context8.t0);

              case 37:
                if (!(!is_string(res_any) || res_any.length === 0 || !is_hex(res_any))) {
                  _context8.next = 39;
                  break;
                }

                throw new Error(["CustomBlockchain: fetch(): res_any should be an hex string (rawtx) but got:", res_any].join(' '));

              case 39:
                // if(this.DEBUG) log("promises res_any=",res_any) // very big outputs
                rawtx = res_any; // save to local cache & return

                if (this.cache) this.cache.set("tx://" + txid, rawtx); // async but we don't need to await here

                return _context8.abrupt("return", rawtx);

              case 42:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this, [[14, 20], [24, 31]]);
      }));

      function _fetch(_x5) {
        return _fetch3.apply(this, arguments);
      }

      return _fetch;
    }()
  }, {
    key: "utxos",
    value: function () {
      var _utxos2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee10(script) {
        var _this6 = this;

        return regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                _context10.next = 2;
                return retry( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee9() {
                  return regeneratorRuntime.wrap(function _callee9$(_context9) {
                    while (1) {
                      switch (_context9.prev = _context9.next) {
                        case 0:
                          _context9.next = 2;
                          return _this6._utxos(script);

                        case 2:
                          return _context9.abrupt("return", _context9.sent);

                        case 3:
                        case "end":
                          return _context9.stop();
                      }
                    }
                  }, _callee9);
                })), this.retry_config);

              case 2:
                return _context10.abrupt("return", _context10.sent);

              case 3:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10, this);
      }));

      function utxos(_x7) {
        return _utxos2.apply(this, arguments);
      }

      return utxos;
    }()
  }, {
    key: "_utxos",
    value: function () {
      var _utxos3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee11(script) {
        var _this7 = this;

        var log, allpromises, res_any;
        return regeneratorRuntime.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                log = function log() {
                  for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
                    args[_key4] = arguments[_key4];
                  }

                  return _this7.log.apply(_this7, ["utxos(): "].concat(args));
                };

                if (this.DEBUG) log("with script=" + script); //
                // our goal is to talk with ALL blockchains to increase reliability
                // and take the response from the FIRST one that fulfils it		

                allpromises = [];
                this.blockchains.forEach(function (blockchain) {
                  allpromises.push(blockchain.utxos(script));
                });
                _context11.prev = 4;
                _context11.next = 7;
                return Promise_Any(allpromises);

              case 7:
                res_any = _context11.sent;
                _context11.next = 14;
                break;

              case 10:
                _context11.prev = 10;
                _context11.t0 = _context11["catch"](4);
                console.error("CustomBlockchain: utxos(): all blockchains failed.");
                throw new Error(["CustomBlockchain: utxos(): all blockchains failed"].join(' '));

              case 14:
                if (Array.isArray(res_any)) {
                  _context11.next = 16;
                  break;
                }

                throw new Error(["CustomBlockchain: utxos(): res_any should be an array but got:", res_any].join(' '));

              case 16:
                if (this.DEBUG) log("promises res_any=", _typeof(res_any), ": ", res_any);
                return _context11.abrupt("return", res_any);

              case 18:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11, this, [[4, 10]]);
      }));

      function _utxos(_x8) {
        return _utxos3.apply(this, arguments);
      }

      return _utxos;
    }()
  }, {
    key: "time",
    value: function () {
      var _time2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee13(txid) {
        var _this8 = this;

        return regeneratorRuntime.wrap(function _callee13$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                _context13.next = 2;
                return retry( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee12() {
                  return regeneratorRuntime.wrap(function _callee12$(_context12) {
                    while (1) {
                      switch (_context12.prev = _context12.next) {
                        case 0:
                          _context12.next = 2;
                          return _this8._time(txid);

                        case 2:
                          return _context12.abrupt("return", _context12.sent);

                        case 3:
                        case "end":
                          return _context12.stop();
                      }
                    }
                  }, _callee12);
                })), this.retry_config);

              case 2:
                return _context13.abrupt("return", _context13.sent);

              case 3:
              case "end":
                return _context13.stop();
            }
          }
        }, _callee13, this);
      }));

      function time(_x9) {
        return _time2.apply(this, arguments);
      }

      return time;
    }()
  }, {
    key: "_time",
    value: function () {
      var _time3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee14(txid) {
        var _this9 = this;

        var log, allpromises, res_any;
        return regeneratorRuntime.wrap(function _callee14$(_context14) {
          while (1) {
            switch (_context14.prev = _context14.next) {
              case 0:
                log = function log() {
                  for (var _len5 = arguments.length, args = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
                    args[_key5] = arguments[_key5];
                  }

                  return _this9.log.apply(_this9, ["time(): "].concat(args));
                };

                if (this.DEBUG) log("with txid=" + txid);

                if (is_string(txid)) {
                  _context14.next = 4;
                  break;
                }

                throw new Error(["CustomBlockchain: time(): must be string, got:", txid].join(' '));

              case 4:
                //
                // our goal is to talk with ALL blockchains to increase reliability
                // and take the response from the FIRST one that fulfils it
                allpromises = [];
                this.blockchains.forEach(function (blockchain) {
                  allpromises.push(blockchain.time(txid));
                });
                _context14.prev = 6;
                _context14.next = 9;
                return Promise_Any(allpromises);

              case 9:
                res_any = _context14.sent;
                _context14.next = 16;
                break;

              case 12:
                _context14.prev = 12;
                _context14.t0 = _context14["catch"](6);
                console.error("CustomBlockchain: time(): all blockchains failed for", txid);
                throw new Error(["CustomBlockchain: time(): all blockchains failed for", txid].join(' '));

              case 16:
                if (Number.isInteger(res_any)) {
                  _context14.next = 18;
                  break;
                }

                throw new Error(["CustomBlockchain: time(): res_any should be an integer but got:", res_any].join(' '));

              case 18:
                if (this.DEBUG) log("promises res_any=", res_any);
                return _context14.abrupt("return", parseInt(res_any));

              case 20:
              case "end":
                return _context14.stop();
            }
          }
        }, _callee14, this, [[6, 12]]);
      }));

      function _time(_x10) {
        return _time3.apply(this, arguments);
      }

      return _time;
    }()
  }, {
    key: "spends",
    value: function () {
      var _spends2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee16(txid, vout) {
        var _this10 = this;

        return regeneratorRuntime.wrap(function _callee16$(_context16) {
          while (1) {
            switch (_context16.prev = _context16.next) {
              case 0:
                _context16.next = 2;
                return retry( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee15() {
                  return regeneratorRuntime.wrap(function _callee15$(_context15) {
                    while (1) {
                      switch (_context15.prev = _context15.next) {
                        case 0:
                          _context15.next = 2;
                          return _this10._spends(txid, vout);

                        case 2:
                          return _context15.abrupt("return", _context15.sent);

                        case 3:
                        case "end":
                          return _context15.stop();
                      }
                    }
                  }, _callee15);
                })), this.retry_config);

              case 2:
                return _context16.abrupt("return", _context16.sent);

              case 3:
              case "end":
                return _context16.stop();
            }
          }
        }, _callee16, this);
      }));

      function spends(_x11, _x12) {
        return _spends2.apply(this, arguments);
      }

      return spends;
    }()
  }, {
    key: "_spends",
    value: function () {
      var _spends3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee18(txid, vout) {
        var _this11 = this;

        var log, spend_txid, get_spend_and_load_it, allpromises, res_any, run_txid, errormess, runapi_spends, mattercloud_spends;
        return regeneratorRuntime.wrap(function _callee18$(_context18) {
          while (1) {
            switch (_context18.prev = _context18.next) {
              case 0:
                log = function log() {
                  for (var _len6 = arguments.length, args = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
                    args[_key6] = arguments[_key6];
                  }

                  return _this11.log.apply(_this11, ["spends(): "].concat(args));
                };

                if (this.DEBUG) log("with txid=" + txid + ", vout=" + vout);

                if (is_string(txid)) {
                  _context18.next = 4;
                  break;
                }

                throw new Error(["CustomBlockchain: spends(): must be string, got:", txid].join(' '));

              case 4:
                if (!this.cache) {
                  _context18.next = 11;
                  break;
                }

                _context18.next = 7;
                return this.cache.get("spend://" + txid + "_o" + vout);

              case 7:
                spend_txid = _context18.sent;

                if (!spend_txid) {
                  _context18.next = 11;
                  break;
                }

                if (this.DEBUG) log("found in cache: ", spend_txid);
                return _context18.abrupt("return", spend_txid);

              case 11:
                //
                // our goal is to talk with ALL blockchains to increase reliability
                // and take the response from the FIRST one that fulfils it
                //
                // BUT the 1-st one might say "no spend" and the second one will find one
                // because the 1st one is slower on syncing on their end.
                // SO to bypass that issue we WILL load a spend that we find later
                // so that another call to spends() or sync() will return the cached spend
                // and not return "no spend" again
                get_spend_and_load_it = /*#__PURE__*/function () {
                  var _ref8 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee17(blockchain, txid, vout) {
                    var spend_txid;
                    return regeneratorRuntime.wrap(function _callee17$(_context17) {
                      while (1) {
                        switch (_context17.prev = _context17.next) {
                          case 0:
                            _context17.next = 2;
                            return blockchain.spends(txid, vout);

                          case 2:
                            spend_txid = _context17.sent;

                            if (!(_this11.cache && spend_txid)) {
                              _context17.next = 6;
                              break;
                            }

                            _context17.next = 6;
                            return _this11.cache.set("spend://" + txid + "_o" + vout, spend_txid);

                          case 6:
                          case "end":
                            return _context17.stop();
                        }
                      }
                    }, _callee17);
                  }));

                  return function get_spend_and_load_it(_x15, _x16, _x17) {
                    return _ref8.apply(this, arguments);
                  };
                }();

                allpromises = [];
                this.blockchains.forEach(function (blockchain) {
                  // whatsonchain api doesn't support spends for now
                  if (blockchain.api !== "whatsonchain") {
                    //allpromises.push(blockchain.spends(txid, vout))
                    allpromises.push(get_spend_and_load_it(blockchain, txid, vout));
                  }
                });
                _context18.prev = 14;
                _context18.next = 17;
                return Promise_Any(allpromises);

              case 17:
                res_any = _context18.sent;
                _context18.next = 27;
                break;

              case 20:
                _context18.prev = 20;
                _context18.t0 = _context18["catch"](14);
                run_txid = txid + "_o" + vout;
                errormess = "CustomBlockchain: spends(): all blockchains failed for " + run_txid;
                console.log(errormess, allpromises);
                console.error(errormess);
                throw new Error(errormess);

              case 27:
                if (!(res_any === undefined || res_any === null || is_string(res_any) && res_any.length > 0 && is_hex(res_any))) {
                  _context18.next = 30;
                  break;
                }

                _context18.next = 48;
                break;

              case 30:
                if (!is_empty_obj(res_any)) {
                  _context18.next = 42;
                  break;
                }

                // we get : {} (type [object object])
                // I have no idea why I get those sometimes, when it should be a txid or null according to run-docs
                console.error("CustomBlockchain: spends(): error: is_empty_obj(res_any)=true, res_any=", res_any);
                _context18.next = 34;
                return this.blockchain_runapi.spends(txid, vout);

              case 34:
                runapi_spends = _context18.sent;
                _context18.next = 37;
                return this.blockchain_mattercloud.spends(txid, vout);

              case 37:
                mattercloud_spends = _context18.sent;
                console.error("CustomBlockchain: spends() for txid=", txid + "_o" + vout + " :", "\n\t runapi_spends=", runapi_spends, "\n\t mattercloud_spends=", mattercloud_spends);
                return _context18.abrupt("return", null);

              case 42:
                if (!(res_any && res_any.spend_txid)) {
                  _context18.next = 47;
                  break;
                }

                console.error("CustomBlockchain: spends():  res_any.spend_txid=", res_any.spend_txid);
                return _context18.abrupt("return", res_any.spend_txid);

              case 47:
                throw new Error(["CustomBlockchain: spends(): " + "res_any should be an hex string (txid) or null, " + "but got: (" + _typeof(res_any) + "):'", res_any, "' (stringified: '", JSON.stringify(res_any), "')" + "for vout=", vout, " & txid=", txid].join(' '));

              case 48:
                if (this.DEBUG) log("promises res_any=", _typeof(res_any), ": ", res_any);

                if (!(res_any === null)) {
                  _context18.next = 51;
                  break;
                }

                return _context18.abrupt("return", null);

              case 51:
                return _context18.abrupt("return", res_any);

              case 52:
              case "end":
                return _context18.stop();
            }
          }
        }, _callee18, this, [[14, 20]]);
      }));

      function _spends(_x13, _x14) {
        return _spends3.apply(this, arguments);
      }

      return _spends;
    }()
  }]);

  return CustomBlockchain;
}(Run.api.Blockchain);

export { CustomBlockchain as default };